<template>
	<div>
		<h1>Theme Editor</h1>
		<p>{{ message }}</p>
	</div>
</template>

<script>
export default {
	props: {
		message: {
			type: 'string',
			default: ''
		}
	},
	data() {
		return {
			count: 0
		}
	},
	mounted() {
		console.log('The Editor is All set')
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/admin/assets/js/app/themes/ThemeEditor.vue